module.exports = __webpack_public_path__ + "static/media/placeholder-card.158ad39e.png";